import React from 'react';
import { images } from '../../../shared/assets/images';

function ResponsiveImage({ src, alt, additionalClasses }) {
  return (
    <div className={`relative group ${additionalClasses}`}>
      <div className="absolute -inset-2 bg-gradient-to-br from-pink-200 via-yellow-100 to-blue-100 rounded-xl blur-lg opacity-30 group-hover:scale-105 transition-transform duration-500" />
      <img
        src={src}
        alt={alt}
        className="relative w-full h-auto rounded-xl shadow-xl transition-transform duration-500 group-hover:scale-105 z-10"
      />
    </div>
  );
}

export default function PricingSection() {
  return (
    <section id="precio" className="relative py-20 px-4 z-10">
      <div className="container mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 mb-24">
          <div className="lg:w-1/2">
            <ResponsiveImage src={images.generalPrice} alt="Tarifas de entrada al parque" />
          </div>
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-3xl font-bold text-blue-800 mb-4">Entradas generales</h2>
            <p className="text-gray-700 text-lg leading-relaxed mb-4">
              Consulta nuestras tarifas generales para acceder a todas las atracciones del parque, con opciones para niños, adultos y packs familiares.
            </p>
            <div className="bg-yellow-100 border-l-4 border-yellow-400 text-yellow-800 p-4 rounded shadow-md">
              Por motivos de higiene y seguridad, es obligatorio el uso de calcetines antideslizantes de Mundolandia dentro de las instalaciones.
            </div>
          </div>
        </div>

        <div className="flex flex-col-reverse lg:flex-row items-center gap-12">
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-3xl font-bold text-blue-800 mb-4">Cumpleaños inolvidables</h2>
            <p className="text-gray-700 text-lg leading-relaxed">
              Ofrecemos packs especiales con actividades, salas privadas y decoración temática para celebrar un cumpleaños lleno de diversión.
            </p>
          </div>
          <div className="lg:w-1/2">
            <ResponsiveImage src={images.birthdayPriceMain} alt="Precios para celebraciones de cumpleaños" />
          </div>
        </div>
      </div>
    </section>
  );
}
